import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useButtonProps } from '@restart/ui/Button';
import clsx from 'clsx';
import { Fragment, forwardRef, } from 'react';
import { useBootstrapPrefix } from 'react-bootstrap/ThemeProvider';
const AsIcon = ({ children }) => (_jsx("span", { className: "btn-inner--icon d-inline-block", children: children }));
const AsText = ({ children }) => (_jsx("span", { className: "btn-inner--text", children: children }));
const RootButton = (rootProps, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
ref) => {
    const { as = 'button', bsPrefix, variant = 'primary', size, active = false, disabled = false, className, 
    // custom
    block, rounded, icon, children, iconPosition, ...props } = rootProps;
    const prefix = useBootstrapPrefix(bsPrefix, 'btn');
    const [buttonProps, { tagName: Component }] = useButtonProps({
        tagName: as,
        disabled,
        ...props,
    });
    const Container = icon ? AsText : Fragment;
    return (_jsxs(Component, { ...buttonProps, ...props, ref: ref, disabled: disabled, className: clsx(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled', block && 'btn-block', rounded && (icon && children == null ? 'rounded-circle' : 'rounded-pill'), icon && (children == null ? 'btn-icon-only' : 'btn-icon')), children: [icon != null && iconPosition !== 'end' && _jsx(AsIcon, { children: icon }), children != null && _jsx(Container, { children: children }), icon != null && iconPosition === 'end' && _jsx(AsIcon, { children: icon })] }));
};
const Button = forwardRef(RootButton);
Button.Icon = AsIcon;
Button.Text = AsText;
export default Button;
//# sourceMappingURL=Button.js.map